import { lazy, Suspense } from 'react';
import { LazyAssetsFallback, type LazyAssetProps } from '@frontend/internal-assets';

const LazyAiWeaveAssistant = lazy(() => import('./svg-components/ai-weave-assistant'));

const AiWeaveAssistant = ({ assetsFallbackProps = {}, customFallback, ...rest }: LazyAssetProps) => (
  <Suspense fallback={customFallback || <LazyAssetsFallback {...assetsFallbackProps} />}>
    <LazyAiWeaveAssistant {...rest} />
  </Suspense>
);

export default AiWeaveAssistant;
